var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 30,
    viewBox: "0 0 154 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2769 4.67773H0V6.74001H13.6322V29.9999H15.6447V6.74001H29.2769V4.67773Z",
    fill: "url(#paint0_linear_1_376)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2769 10.3186H19.1509V30H20.2309V11.418H29.2769V10.3186Z",
    fill: "url(#paint1_linear_1_376)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2769 15.0466H23.7371V29.9999H24.6206V15.9592H29.2769V15.0466Z",
    fill: "url(#paint2_linear_1_376)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2839 19.5593H28.5827V30H29.2839V19.5593Z",
    fill: "url(#paint3_linear_1_376)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2769 0H0V1.0994H29.2769V0Z",
    fill: "url(#paint4_linear_1_376)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.3186H10.126V30H9.05305V11.418H0V10.3186Z",
    fill: "url(#paint5_linear_1_376)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.0466H5.54683V29.9999H4.65625V15.9592H0V15.0466Z",
    fill: "url(#paint6_linear_1_376)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.701243 19.5593H0V30H0.701243V19.5593Z",
    fill: "url(#paint7_linear_1_376)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5067 10.4479H42.8039V25.5018H48.8977V10.4479H55.2019V4.62036H36.5067V10.4479Z",
    fill: "#150E2A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1791 20.1268C64.318 20.1268 62.3125 17.6837 62.3125 14.9891C62.3125 12.2873 64.325 9.88012 67.1791 9.88012C70.0331 9.88012 72.0387 12.3017 72.0387 14.9891C72.0387 17.6765 70.0402 20.1268 67.1791 20.1268ZM67.1791 3.93042C60.938 3.93042 56.2116 8.8885 56.2116 14.9891C56.2116 21.0825 60.938 26.0765 67.1791 26.0765C73.4202 26.0765 78.1465 21.0897 78.1465 14.9891C78.1465 8.8885 73.4272 3.93042 67.1791 3.93042Z",
    fill: "#150E2A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8194 17.9641L100.979 4.62036H93.3144L87.0102 11.5473V4.62036H80.9234V25.5018H87.0102V19.9473L88.8194 17.9641L94.5065 25.5018H101.533L95.8459 17.9641H88.8194Z",
    fill: "#150E2A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.301 16.8431L113.517 10.5629L115.733 16.8359L111.301 16.8431ZM109.962 4.62036L102.003 25.509H108.244L109.583 21.7437H117.458L118.77 25.509H125.011L117.066 4.62036H109.962Z",
    fill: "#150E2A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M136.721 15.0467H132.815V10.0599H136.721C138.271 10.0599 139.288 11.1665 139.288 12.5389C139.288 13.9114 138.264 15.0467 136.721 15.0467ZM137.1 4.62036H126.722V25.509H132.815V20.4862H137.1C142.458 20.4862 145.354 16.9293 145.354 12.5389C145.354 8.14851 142.465 4.62036 137.1 4.62036Z",
    fill: "#150E2A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154 4.62036H147.906V25.509H154V4.62036Z",
    fill: "#150E2A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_376",
    x1: 10.5071,
    y1: -7.67788,
    x2: 22.8585,
    y2: 30.4314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0431,
    stopColor: "#EDADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1143,
    stopColor: "#E07FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1826,
    stopColor: "#D55BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2462,
    stopColor: "#CE41FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3034,
    stopColor: "#CA31FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3487,
    stopColor: "#C82CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4205,
    stopColor: "#C324FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5298,
    stopColor: "#B60FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5921,
    stopColor: "#AD00E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8200AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_376",
    x1: 15.1579,
    y1: -9.18506,
    x2: 27.5094,
    y2: 28.9242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0296,
    stopColor: "#EDADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0786,
    stopColor: "#E07FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1255,
    stopColor: "#D55BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1692,
    stopColor: "#CE41FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2086,
    stopColor: "#CA31FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2397,
    stopColor: "#C82CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3436,
    stopColor: "#C324FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5019,
    stopColor: "#B60FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5921,
    stopColor: "#AD00E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8200AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_376",
    x1: 16.577,
    y1: -9.64513,
    x2: 28.9284,
    y2: 28.4641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0296,
    stopColor: "#EDADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0786,
    stopColor: "#E07FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1255,
    stopColor: "#D55BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1692,
    stopColor: "#CE41FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2086,
    stopColor: "#CA31FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2397,
    stopColor: "#C82CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3436,
    stopColor: "#C324FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5019,
    stopColor: "#B60FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5921,
    stopColor: "#AD00E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8200AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_376",
    x1: 18.1458,
    y1: -10.1535,
    x2: 30.4973,
    y2: 27.9558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0296,
    stopColor: "#EDADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0786,
    stopColor: "#E07FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1255,
    stopColor: "#D55BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1692,
    stopColor: "#CE41FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2086,
    stopColor: "#CA31FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2397,
    stopColor: "#C82CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3436,
    stopColor: "#C324FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5019,
    stopColor: "#B60FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5921,
    stopColor: "#AD00E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8200AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_376",
    x1: 11.9547,
    y1: -8.14692,
    x2: 24.3061,
    y2: 29.9624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0296,
    stopColor: "#EDADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0786,
    stopColor: "#E07FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1255,
    stopColor: "#D55BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1692,
    stopColor: "#CE41FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2086,
    stopColor: "#CA31FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2397,
    stopColor: "#C82CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3436,
    stopColor: "#C324FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5019,
    stopColor: "#B60FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5921,
    stopColor: "#AD00E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8200AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_376",
    x1: 0.354267,
    y1: -4.38714,
    x2: 12.7057,
    y2: 33.7221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0149,
    stopColor: "#E9ADFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0672,
    stopColor: "#DD7FFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1175,
    stopColor: "#D45BFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "#CD41FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2064,
    stopColor: "#C931FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2397,
    stopColor: "#C82CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3436,
    stopColor: "#C324FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5019,
    stopColor: "#B60FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5921,
    stopColor: "#AD00E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8200AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_376",
    x1: -3.02776,
    y1: -3.29109,
    x2: 9.32364,
    y2: 34.8182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0296,
    stopColor: "#EDADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0786,
    stopColor: "#E07FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1255,
    stopColor: "#D55BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1692,
    stopColor: "#CE41FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2086,
    stopColor: "#CA31FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2397,
    stopColor: "#C82CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3436,
    stopColor: "#C324FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5019,
    stopColor: "#B60FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5921,
    stopColor: "#AD00E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8200AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_376",
    x1: -7.83478,
    y1: -1.73298,
    x2: 4.51662,
    y2: 36.3763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0296,
    stopColor: "#EDADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0786,
    stopColor: "#E07FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1255,
    stopColor: "#D55BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1692,
    stopColor: "#CE41FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2086,
    stopColor: "#CA31FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2397,
    stopColor: "#C82CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3436,
    stopColor: "#C324FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5019,
    stopColor: "#B60FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5921,
    stopColor: "#AD00E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8200AF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg9);
export default __webpack_public_path__ + "static/media/img9.3671748ac4006290b0bcc0a332f56da0.svg";
export { ForwardRef as ReactComponent };